'use client';

import { Checkbox, type CheckboxProps } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';

type InternalNetworkGraphControlsProps = {
  showNodeLabels: boolean;
  onShowNodeLabelsChange: (value: boolean) => void;
  showEdgeLabels: boolean;
  onShowEdgeLabelsChange: (value: boolean) => void;
};

export function InternalNetworkGraphControls({
  showNodeLabels,
  onShowNodeLabelsChange,
  showEdgeLabels,
  onShowEdgeLabelsChange,
}: InternalNetworkGraphControlsProps) {
  const t = useTranslations('internalNetwork.graph.controls');

  const handleNodeLabelsChange: CheckboxProps['onCheckedChange'] = (details) =>
    onShowNodeLabelsChange(details.checked === true);

  const handleEdgeLabelsChange: CheckboxProps['onCheckedChange'] = (details) =>
    onShowEdgeLabelsChange(details.checked === true);

  return (
    <Box bg="canvas" borderRadius="sm" boxShadow="sm" p={2}>
      <HStack gap={3} alignItems="center">
        <Checkbox
          checked={showNodeLabels}
          onCheckedChange={handleNodeLabelsChange}
          size="sm"
          colorPalette="gray"
        >
          {t('nodeLabels')}
        </Checkbox>
        <Checkbox
          checked={showEdgeLabels}
          onCheckedChange={handleEdgeLabelsChange}
          size="sm"
          colorPalette="gray"
        >
          {t('edgeLabels')}
        </Checkbox>
      </HStack>
    </Box>
  );
}
